import { useTranslation } from "@bounce/i18n"

import { useCityPriceInterpolations } from "../../../LuggageStorage/CityScreen/hooks/useCityPriceInterpolations"
import type { Interpolations } from "../hooks/useInterpolations"
import {
  LogoStructuredData,
  ProductReviewStructuredData,
  WebsiteStructuredData,
} from "@/components/Generic/StructuredData/StructuredData"
import type { AggregateRating } from "@/libs/bounce/aggregateRating"
import type { GetStoreLocationQuery } from "@/libs/bounce/bounceSdk.types.gen"
import { getStoreThumbnail } from "@/libs/bounce/stores/getStoreThumbnail"
import { useStoreUrl } from "@/libs/router"
import type { Review } from "@/utils/reviews"

type StructuredDataProps = {
  store: GetStoreLocationQuery["store"]
  reviews: Review[]
  aggregateRating: AggregateRating
  metaDescription: string
  interpolations: Interpolations
}

export const StructuredData = ({
  store,
  aggregateRating,
  metaDescription,
  reviews,
  interpolations,
}: StructuredDataProps) => {
  const {
    t,
    i18n: { language },
  } = useTranslation("marketing-ls-store")
  const { lowestPrice, city } = store
  const { priceAmountForStructuredData } = useCityPriceInterpolations({ lowestPrice, currency: city.currency })
  const { absolutePath } = useStoreUrl({ store })
  const thumbnail = getStoreThumbnail(store, { width: 1200, height: 1200 })
  const name = t("screen.storeScreen.structuredData.name", "Luggage storage {STORE_NAME}", interpolations)

  return (
    <>
      <WebsiteStructuredData alternateName={name} language={language} />
      <LogoStructuredData />
      <ProductReviewStructuredData
        name={name}
        description={metaDescription}
        image={thumbnail || store.staticMapUrl}
        url={absolutePath}
        ratingValue={aggregateRating.rating}
        reviewCount={aggregateRating.count}
        reviews={reviews}
        lowestPrice={priceAmountForStructuredData}
        currency={city.currency}
      />
    </>
  )
}
